module.exports = __webpack_public_path__ + "static/img/intro.c473650a.jpg";